import React, { useEffect, useState } from "react";
import { FaHeart } from "react-icons/fa6";
import "./index.css";
import SavedSearch from "./SavedSearch";
import SavedProperties from "./SavedProperties";
import heartBorder from "../../../../../public/assets/images/srp/heartBorder.svg";
import { getEventCategory, trackButtonClick } from "@/utils/analytics";
import { getCookie } from "@/utils/cookies";
import { useDispatch, useSelector } from "react-redux";
import { setLoginCallLocation, setLoginModal, setLoginTab, setShowContinueBtn, setShowTabsInModal } from "@/redux/login/loginSlice";

const SavedPreference = () => {
  const [activeTab, setActiveTab] = useState("Properties");
  const [userSubscribed, setIsUserSubscribed] = useState(
    getCookie("subscribedUser") || false
  );
    const globalPopup = useSelector((state) => state.login);
    const dispatch = useDispatch();

  useEffect(() => {
    const offcanvasElement = document.getElementById("ss");

    // Function to trac when offcanvas is hidden
    const handleOffcanvasHidden = () => {
      let eventCategory = getEventCategory();

      trackButtonClick({
        eventName: "save_list_slider_close",
        eventCategory: `${eventCategory} - Save List Slider`,
        eventSource: "Save slider close",
      });
    };

    // Event listener for when offcanvas is hidden
    if (offcanvasElement) {
      offcanvasElement.addEventListener(
        "hidden.bs.offcanvas",
        handleOffcanvasHidden
      );
    }

    // Cleanup function to remove event listener when component unmounts
    return () => {
      if (offcanvasElement) {
        offcanvasElement.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasHidden
        );
      }
    };
  }, []);

    useEffect(() => {
      if (globalPopup.isUserSubscribed) {
        setIsUserSubscribed(true);
      } else {
        setIsUserSubscribed(false);
      }
    }, [globalPopup.isUserSubscribed]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);

    let eventCategory = getEventCategory();

    trackButtonClick({
      eventName: "save_list_slider_tab_click",
      eventCategory: `${eventCategory} - Save List Slider`,
      eventSource: "Save slider tab click",
      eventLabel: `Tab Name : ${tabName}`,
    });
  };

  const handleCompleteProfile = () => {
    document.body.style.overflow = "";
    document.body.style.padding = "";
    dispatch(setLoginTab("regsiterTab"));
    dispatch(setLoginCallLocation("Popup"));
    dispatch(setLoginModal(true));
    dispatch(setShowTabsInModal(false))
    dispatch(setShowContinueBtn(true))
  }

  return (
    <>
      <div className="offcanvas-header">
        <h2 className="offcanvas-title saved-title">
          <img src={heartBorder} alt="heartIcon.png" />
          Saved
        </h2>
        <button
          type="button"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        {
          userSubscribed?
          <div className="text-center mt-4">
            <button className="btn complete-your-profile-saved"  data-bs-dismiss="offcanvas" onClick={handleCompleteProfile}>Complete your profile</button>

          </div>
          :

        <div className="sidebar_listing_list preference-body">
          <ul className="preference-headings">
            <li
              onClick={() => handleTabClick("Properties")}
              className={`${
                activeTab === "Properties" ? "active-heading" : "normal-heading"
              }`}
            >
              Properties
            </li>
            <li
              onClick={() => handleTabClick("Search")}
              className={`${
                activeTab === "Search" ? "active-heading" : "normal-heading"
              }`}
            >
              Searches
            </li>
          </ul>
          <div className="preference-data">
            {activeTab === "Search" ? (
              <SavedSearch />
            ) : (
              <SavedProperties
                isSidebarVisible={activeTab === "Properties" ? true : false}
              />
            )}
          </div>
        </div>
}
      </div>
    </>
  );
};

export default SavedPreference;
